import React from 'react'
import styles from './header.module.scss'

export default function CollapseHeader({
    collapsed,
    setCollapsed,
    headerTag,
}: {
    collapsed: boolean
    setCollapsed: React.Dispatch<React.SetStateAction<boolean>>
    headerTag: string
}) {
    return (
        <h1 onClick={() => setCollapsed(!collapsed)}>
            <img src="/icons/arrow-black.png" alt=">" className={styles.arrow + ' ' + (!collapsed && styles.rotated)} />
            {headerTag}
        </h1>
    )
}
